<template>
  <div class="header_logo">
    <el-menu background-color="var(--main-theme-color)" mode="horizontal" :router="true" class="el-menu-vertical-demo">
      <el-menu-item>
        <div class="logo-box">
          <el-image class="logo" :src="logo"></el-image>
        </div>
      </el-menu-item>
      <el-menu-item v-for="item in leftMenu" :key="item.id" :index="item.url">
        <template slot="title"><i :class="item.icon"></i>{{ item.menu }}</template>
      </el-menu-item>
    </el-menu>
    <div class="middle">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      leftMenu: [
        {
          id: 1,
          menu: '商城首页',
          url: '/',
          icon: 'el-icon-s-home'
        },
        {
          id: 2,
          menu: '用户中心',
          url: '/userCenter',
          icon: 'el-icon-user'
        },
        {
          id: 3,
          menu: '支付中心',
          url: '/paymentCenter',
          icon: 'el-icon-coin'
        },
      ],
    };
  },
  computed:{
    logo () {
      return this.$store.state.logo;
    },
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {},
};
</script>

<style scoped lang="less">
.header_logo {
  height: 100%;
  .logo-box{
    height: 100%;
    line-height: 1;
    .logo{
      height: 100%;
    }
  }
  .xunyouText {
    width: 100px;
    height: auto;
  }

  li.el-menu-item {
    color: white !important;
    font-size: 16px;

    i {
      color: white;
      vertical-align: inherit;
    }
  }
}

.breakcrumbHeader {
  margin: 15px 0;
}
</style>







// WEBPACK FOOTER //
// src/views/siteNavigation/siteNavigation.vue